// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"e638f4cd988b7fae505b","293":"a0eb75b2aaa87a5b03b3","518":"26341c0e9c2e70018d93","779":"1668ae473c1c21c3293f"}[chunkId] + ".js";
};